<script context="module">
  import AdditionalHelp from "./Components/AdditionalHelp.svelte";
  import Alerts from "./Shared/Alerts.svelte";
  export { default as layout } from "./Shared/Layout.svelte";
</script>

<script>
  import { inertia } from "@inertiajs/svelte";
  import HomeFaq from "./FAQ/HomeFaq.svelte";

  const handleCardHoverIn = (e) => {
    e.target.querySelector(".bi").classList.remove("text-opacity-75");
    e.target.querySelector(".bi").style["transform"] =
      "translate3d(0, -.125rem, 0)";
    e.target.querySelector(".card-body").style.backgroundColor =
      "var(--bs-primary-border-subtle) !important";
  };
  const handleCardHoverOut = (e) => {
    e.target.querySelector(".bi").classList.add("text-opacity-75");
    e.target.querySelector(".card-body").style.backgroundColor = "";
    e.target.querySelector(".bi").style["transform"] = "initial";
  };

  let startIconType = "caret-right";
</script>

<div class="row mt-2">
  <div class="col-12 col-md-8">
    <Alerts />
    <div class="card mb-3">
      <div class="card-header fs-3">Arkansas STreamline Auto Renewal</div>
      <div class="card-body">
        <div class="row align-items-center">
          <div class="col-12 col-md-8">
            Renew your vehicle registration, change your mailing address & set
            up reminders - all in one step.
          </div>
          <div class="col mt-4 mt-md-0 align-content-center">
            <a
              use:inertia={{ preserveState: true }}
              id="getStarted"
              href={window.route("renewal.search")}
              on:mouseover={() => (startIconType = "caret-right-fill")}
              on:mouseout={() => (startIconType = "caret-right")}
              class="btn btn-success d-block w-100 py-3 fs-5 fw-light icon-link icon-link-hover d-inline-flex align-items-center justify-content-center"
              >Get Started
              <svg class="bi fs-4" width="16" height="16" fill="currentColor">
                <use
                  xlink:href={`${import.meta.env.VITE_ASSET_URL}/images/icons.svg#${startIconType}`}
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="row gx-1 mt-4">
      <div class="col-12">
        <p class="text-left mx-4">
          <strong>Already renewed?</strong> Change your address, setup reminders
          for next year, or print your renewal receipt.
        </p>
      </div>
      <div class="col-12 col-md text-center d-grid fw-light">
        <div
          class="card mb-3 bg-light border-primary-subtle"
          on:mouseenter={(e) => handleCardHoverIn(e)}
          on:mouseleave={(e) => handleCardHoverOut(e)}
        >
          <div class="card-header bg-transparent">
            <div class="icon-link icon-link-hover">
              <svg
                class="bi d-block text-opacity-75 text-primary"
                style="font-size: 4em;line-height: 1em;"
                width="16"
                height="16"
                fill="currentColor"
              >
                <use
                  xlink:href={`${import.meta.env.VITE_ASSET_URL}/images/icons.svg#envelope`}
                />
              </svg>
            </div>
          </div>
          <div
            class="card-body bg-primary-subtle py-2 d-flex align-items-center justify-content-center"
          >
            <a
              href={window.route("address.index")}
              use:inertia
              class="stretched-link text-dark text-decoration-none hover-icon"
              >Change Your Address</a
            >
          </div>
        </div>
      </div>
      <div class="col-12 col-md text-center d-grid fw-light">
        <div
          class="card mb-3 bg-light border-primary-subtle"
          on:mouseenter={(e) => handleCardHoverIn(e)}
          on:mouseleave={(e) => handleCardHoverOut(e)}
        >
          <div class="card-header bg-transparent">
            <div class="icon-link icon-link-hover">
              <svg
                class="bi d-block text-opacity-75 text-primary"
                style="font-size: 4em;line-height: 1em;"
                width="16"
                height="16"
                fill="currentColor"
              >
                <use
                  xlink:href={`${import.meta.env.VITE_ASSET_URL}/images/icons.svg#clock`}
                />
              </svg>
            </div>
          </div>
          <div
            class="card-body bg-primary-subtle py-2 d-flex align-items-center justify-content-center"
          >
            <a
              href={window.route("reminders.index")}
              use:inertia
              class="stretched-link text-dark text-decoration-none"
              >Renewal Reminders</a
            >
          </div>
        </div>
      </div>
      <div class="col-12 col-md text-center d-grid fw-light">
        <!-- @TODO: Find renewal receipt url -->
        <div
          class="card mb-3 bg-light border-primary-subtle"
          on:mouseenter={(e) => handleCardHoverIn(e)}
          on:mouseleave={(e) => handleCardHoverOut(e)}
        >
          <div class="card-header bg-transparent">
            <div class="icon-link icon-link-hover">
              <svg
                class="bi d-block text-opacity-75 text-primary"
                style="font-size: 4em;line-height: 1em;"
                width="16"
                height="16"
                fill="currentColor"
              >
                <use
                  xlink:href={`${import.meta.env.VITE_ASSET_URL}/images/icons.svg#receipt`}
                />
              </svg>
            </div>
          </div>
          <div
            class="card-body bg-primary-subtle py-2 d-flex align-items-center justify-content-center"
          >
            <a
              href={window.route("receipt.index")}
              use:inertia
              class="stretched-link text-dark text-decoration-none"
              >Find Renewal Receipt</a
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center mt-md-4 justify-content-center">
      <div class="col-auto">
        <span class="pay-with-text" style="height:32px">Pay securely with</span>
      </div>
      <div class="col-auto">
        <span class="payment-types">
          <i class="icon-cc icon-ax" title="American Express"></i>
          <i class="icon-cc icon-ds" title="Discover"></i>
          <i class="icon-cc icon-mc" title="MasterCard"></i>
          <i class="icon-cc icon-vs" title="Visa"></i>
          <i class="icon-ec" title="E-Check"></i>
        </span>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-4 mt-4 mt-md-0">
    <HomeFaq />
    <AdditionalHelp />
  </div>
</div>
